import React from "react";
import cert1 from "../../assets/img/brochure/cert-1-research.jpg";
import cert2 from "../../assets/img/brochure/cert-2-sw.jpg";
import cert3 from "../../assets/img/brochure/cert-3-production.jpg";
import cert4 from "../../assets/img/brochure/cert-4-venture.jpg";
import cert5 from "../../assets/img/brochure/cert-5-ai-membership.jpg";
import Reveal from "../common/Reveal";

const CERTIFICATIONS = [
  {
    photo: cert1,
    name: "기업부설연구소",
    description: "과학기술정보통신부 인정 기업부설연구소",
  },
  {
    photo: cert2,
    name: "벤처기업확인",
    description: "혁신성장유형 벤처기업확인서",
  },
  {
    photo: cert3,
    name: "S/W사업자확인",
    description: "소프트웨어사업자 신고확인서 발급",
  },
  {
    photo: cert4,
    name: "직접생산확인",
    description: "중소벤처기업부 직접생산 확인증명",
  },
  {
    photo: cert5,
    name: "경기도 AI 멤버십",
    description: "경기도경제과학진흥원 AI 멤버십 기업 인증",
  },
];

const Certifications = () => {
  return (
    <section className="bg-gradient-to-b from-white to-primary-50/40 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            Certifications
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            회사 인증
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-5">
          {CERTIFICATIONS.map((cert, index) => (
            <Reveal
              key={cert.name}
              delay={index * 80}
              className="group h-full overflow-hidden rounded-xl border border-transparent bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="overflow-hidden">
                <img
                  src={cert.photo}
                  alt={`${cert.name} 인증서`}
                  className="h-44 w-full scale-105 object-cover object-top transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-primary-900">
                  {cert.name}
                </h3>
                <p className="mt-1 break-keep text-sm text-gray-600">
                  {cert.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
